<div class="form-group">
  <label for="rolName">Role Name:</label>
  <input type="text" class="form-control" id="name" [(ngModel)]="role.rolName" />
</div>
<p-footer>
  <div class="footer">
    <button type="button" (click)="closeModalRole()" class="btn btn-secondary mr-2">Cancel</button>
    <button type="submit" class="btn btn-primary createBtn" (click)="createNewRole(role)">
      Create
    </button>
  </div>
</p-footer>
